module.exports = __webpack_public_path__ + "static/media/model-l200-96.79682ce9.webp";